import React, { useContext, useState } from 'react';
import styled from 'styled-components';
import { Flex } from '../atom/Layout';
import { CheckIcon } from '../atom/Icon';
import { Text } from '../atom/Text';

import ModalContext from '../../../modules/contexts/Modalcontext';
import { formatDate } from '../../../lib/util/Date';
import * as PATH from '../../../lib/routes/path';

export const isShowOrderAllowMarketing = (initialValue) => {
  return window.location.pathname === PATH.ORDER && !initialValue;
};

export const doConfirmAllowMarketing = (allowMarketing) =>
  window.confirm(
    allowMarketing
      ? '마케팅 정보 수신 동의를 철회 하시겠습니까?'
      : '마케팅 정보 수신을 동의 하시겠습니까?',
  );

export const AllowMarketingCheck = ({
  allowMarketing = false,
  onClick = () => {},
  isShowTerms = true,
  margin = '0',
  titleSize = 16,
}) => {
  const { onModal } = useContext(ModalContext).actions;

  return (
    <Flex column style={{ margin }} alignItems="flex-start">
      {isShowTerms && (
        <Flex justifyContent="space-between" padding="0 0 0.65rem" width="100%">
          <Text size={titleSize}>[선택] 마케팅 수신 동의</Text>
          <Text
            size={12}
            color="brownGrey"
            style={{ cursor: 'pointer' }}
            onClick={() =>
              onModal({
                title: '마케팅 수신 동의',
                content: <Text size={12}>{MARKETING_TERMS}</Text>,
              })
            }
          >
            자세히 보기
          </Text>
        </Flex>
      )}
      <Flex onClick={onClick} style={{ cursor: 'pointer' }}>
        <CheckIcon
          defaultBackgroundColor="pinkishGrey"
          checked={allowMarketing}
        />
        <Text size={12} style={{ marginLeft: '0.5rem' }}>
          베이비페이스에서 보내는 마케팅/혜택 알림에 동의합니다.
        </Text>
      </Flex>
    </Flex>
  );
};

export const AllowMarketingInduceModal = ({
  allowMarketing = false,
  onClick = (_) => {},
  modalText = '',
}) => {
  const [checked, setChecked] = useState(allowMarketing);

  return (
    <Flex column width="100%">
      <ModalText>{modalText}</ModalText>
      <AllowMarketingCheck
        allowMarketing={checked}
        onClick={() => onClick(setChecked)}
        isShowTerms={false}
        margin="1.65rem 0 0"
      />
    </Flex>
  );
};

export const AllowMarketingNotiModal = ({
  updateDateTime = '',
  allowMarketing = false,
}) => {
  return (
    <ModalText>
      {updateDateTime && `${formatDate(new Date(updateDateTime)).textYMD}\n`}
      {allowMarketing
        ? '마케팅/혜택 알림에 동의하셨습니다.\n페이백 등 다양한 이벤트에\n참여하실 수 있어요.'
        : '마케팅/혜택 알림 동의가 철회되었습니다.'}
    </ModalText>
  );
};

export const ORDER_INDUCE = {
  title: '잠깐!',
  text: `마케팅 혜택 알림에 동의하고\n리뷰 페이백 1천원, 출산 후기 100% 선물\n이벤트 참여하세요.`,
};
export const SIGNUP_INDUCE = {
  title: '지금만 드려요!',
  text: `가입 시 마케팅/정보 수신 동의하면\n베이비페이스 1천원 쿠폰을 드립니다.`,
};
export const BEFORE_REVIEW_INDUCE = {
  title: '잠깐!',
  text: `마케팅/정보 수신에 동의하고 페이백 받으세요.\n(미동의 시 페이백 제외)`,
};
export const AFTER_REVIEW_INDUCE = {
  title: '잠깐!',
  text: `마케팅/정보 수신에 동의하고 응모하세요.\n(미동의 시 이벤트 응모 제외)`,
};

const MARKETING_TERMS = (
  <>
    개인정보보호법 제22조 제4항에 의해 선택정보 사항에 대해서는 기재하지
    않으셔도 서비스를 이용하실 수 있습니다.
    <br />
    <br /> ① 마케팅 및 광고에의 활용
    <br /> – 신규 기능 개발 및 맞춤 서비스 제공
    <br /> – 뉴스레터 발송, 새로운 기능(제품)의 안내
    <br /> – 할인 및 쿠폰 등 이벤트 등 광고성 정보 제공
    <br />
    <br /> ② 베이비페이스 서비스를 운용함에 있어 각종 정보를 서비스 화면, SMS,
    이메일 등의 방법으로 회원에게 제공할 수 있으며, 결제안내 등 의무적으로
    안내되어야 하는 정보성 내용 및 일부 혜택성 정보는 수신동의 여부와 무관하게
    제공합니다.
  </>
);

const ModalText = styled(Text)`
  text-align: center;
  line-height: 1.5;
  white-space: pre-line;
`;
